import { Component } from '@angular/core';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css']
})
export class OverviewComponent {
  speed = 150;
  fanActiveStatus = 2;
  batteryLevel = 90;
}
